import React from 'react';
import googleSheetsImport from '../../images/integrations/Google-Sheets-Import.svg';

import IntegrationBot from '../../components/integrationn/index';

const GoogleSheetsImport = () => <IntegrationBot botLogo={googleSheetsImport} botName={'Google Sheets Import'} />;

export default GoogleSheetsImport;
